import {makeStyles} from '@material-ui/core';
import {APP, DEFAULT_RED_COLOR} from 'src/style/variable';

export const TicketingSystemTimerStyles = makeStyles(() => ({
  runningTimeDiv: {
    marginLeft: 5,
    fontSize: '1rem',
    fontWeight: 700
  },
  stopTimerButton: {
    padding: '0.2rem 0.5rem',
    backgroundColor: DEFAULT_RED_COLOR,
    color: APP.COLOR.DEFAULT.WHITE,
    '&:hover': {
      backgroundColor: DEFAULT_RED_COLOR,
      color: APP.COLOR.DEFAULT.WHITE
    }
  },
  accessTimeIcon: {
    fontSize: '19px',
    marginBottom: '2px',
    display: 'flex',
    alignItems: 'center'
  },
  stopTimeWrapperDefault: {
    display: 'flex',
    alignItems: 'center'
  },
  stopTimeWrapperTopAppBar: {
    backgroundColor: APP.COLOR.DEFAULT.WHITE,
    color: APP.COLOR.PRIMARY,
    padding: '2px 4px',
    borderRadius: '4px'
  },
  stopTimerButtonWrapper: {
    marginLeft: '8px'
  },
  stopTimerButtonLabel: {
    marginLeft: '-5px',
    whiteSpace: 'nowrap'
  },
  startTimerButton: {
    padding: '0.2rem 0.5rem',
    backgroundColor: APP.COLOR.PRIMARY,
    color: APP.COLOR.DEFAULT.WHITE
  },
  startTimerButtonTopAppBar: {
    backgroundColor: APP.COLOR.DEFAULT.WHITE,
    color: APP.COLOR.PRIMARY
  },
  floatingTimerWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 5,
    backgroundColor: '#dfecf4',
    width: 200,
    height: 200,
    borderRadius: '50%',
    justifyContent: 'center',
    color: APP.COLOR.PRIMARY,
    fontWeight: 'bold',
    fontSize: '2.5rem',
    position: 'relative',
    boxShadow:
      '-12px -12px 24px rgba(108, 141, 194, 0.1), 12px 10px 24px rgba(108, 141, 194, 0.25)'
  },
  stopTimeFloatingTimer: {
    color: APP.COLOR.DEFAULT.WHITE,
    position: 'absolute',
    bottom: '-24',
    right: '-24',
    width: 88,
    height: 88,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    fontSize: '1rem',
    backgroundColor: DEFAULT_RED_COLOR,
    border: 0,
    whiteSpace: 'nowrap',
    boxShadow:
      '-12px -12px 24px rgba(194, 108, 108, 0.1), 12px 10px 24px rgba(194, 108, 108, 0.25)'
  },
  startTimerLabel: {
    marginLeft: '-5px',
    whiteSpace: 'nowrap',
    lineHeight: 1
  },
  stopTimerLabel: {
    fontWeight: 'bold'
  },
  ticketStartTimer: {
    '& .MuiButton-startIcon': {
      marginRight: '4px !important'
    }
  }
}));
